export default __webpack_public_path__ + "static/media/Dhruvi_Sherathiya.89d14da7.jpg";